import type { LoaderFunction } from 'react-router-dom';
import { apiListGetUserByToken } from '../../components/ui_components/ApiList';
import { redirect } from 'react-router-dom';

async function checkHasCatalogAccess(): Promise<boolean> {
  try {
    const user = await apiListGetUserByToken();
    if (!user || !user.username) return false;
    return !!(user.is_founder || user.is_admin || user.is_super_admin);
  } catch {
    return false;
  }
}

export const CatalogRouteProtection: LoaderFunction = async () => {
  const hasAccess = await checkHasCatalogAccess();
  if (!hasAccess) return redirect('/');
  return null;
};
